<div>
    <ng-container *ngIf="!chosenPipeline">
        <app-pipeline-selection
            (selectPipeline)="selectPipeline($event)"
            class="default-dialog-layout"
        ></app-pipeline-selection>
    </ng-container>
    <ng-container *ngIf="chosenPipeline === PipelineTypeEnum.Segmentation">
        <app-segmentation-selection
            class="default-dialog-layout"
            [siblingDatasets]="siblingDatasets ?? []"
        ></app-segmentation-selection>
    </ng-container>
    <ng-container *ngIf="chosenPipeline === PipelineTypeEnum.NucleusExpansion">
        <app-nucleus-expansion-selection
            class="default-dialog-layout"
            [siblingDatasets]="siblingDatasets ?? []"
        ></app-nucleus-expansion-selection>
    </ng-container>
    <ng-container *ngIf="chosenPipeline === PipelineTypeEnum.Registration">
        <app-registration-selection
            class="default-dialog-layout"
            [siblingDatasets]="siblingDatasets ?? []"
        ></app-registration-selection>
    </ng-container>
    <ng-container *ngIf="chosenPipeline === PipelineTypeEnum.MapIntensity">
        <app-intensity-selection
            class="default-dialog-layout"
            [siblingDatasets]="siblingDatasets ?? []"
        ></app-intensity-selection>
    </ng-container>
    <ng-container *ngIf="chosenPipeline === PipelineTypeEnum.Clustering">
        <app-clustering-selection class="default-dialog-layout"></app-clustering-selection>
    </ng-container>
    <ng-container *ngIf="chosenPipeline === PipelineTypeEnum.RecurrentNeighborhoods">
        <app-recurrent-neighborhoods-selection
            class="default-dialog-layout"
            [siblingDatasets]="siblingDatasets ?? []"
        ></app-recurrent-neighborhoods-selection>
    </ng-container>
    <ng-container *ngIf="chosenPipeline === PipelineTypeEnum.NeighborhoodEnrichment">
        <app-neighborhood-enrichment-selection
            class="default-dialog-layout"
            [siblingDatasets]="siblingDatasets ?? []"
        ></app-neighborhood-enrichment-selection>
    </ng-container>
    <ng-container *ngIf="chosenPipeline === PipelineTypeEnum.AutoCellDetection">
        <app-auto-cell-detection
            class="default-dialog-layout"
            [siblingDatasets]="siblingDatasets ?? []"
        ></app-auto-cell-detection>
    </ng-container>
</div>
